import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
//import Breadcrumbs
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DataTableHelper from "../../../helpers/tables/DataTableHelper"
import Columns from './Columns'
import AddUpdModal from './AddUpdModal'
import { getPermissions,deletePermission } from '../../../helpers/backend_helper';
import {DestroyAlertHelper,Alert} from '../../../helpers/alerts/alertHelper';
import {Container} from "reactstrap";
import { useParams } from 'react-router-dom';

const Permissions = () => {
    const [pending, setPending] = useState(false);
    const [modal, setModal] = useState({show:false,update:false});
    const {id} = useParams();
    const [items, setItems] = useState([]);
    const [permission, setPermission] = useState({
        id: 0,
        privilege_id:null,
        privilege:{},
        permission_id:null,
        permission:{},
        profile_id:id
    });
    const [dataPag, setDataPag] = useState({});
    const [filters,setFilters] = useState({page:1,perPage:20,search:'',orderBy:'id',order:'asc'});

    useEffect(() => {
        let params={params:filters}
        setPending(true)
        getPermissions(id,params).then(response => {
            setItems(response.data)
            setDataPag(response.meta)
            setPending(false)
        }
        )
    }, [filters])

    const addUpd = (row) => {
        if(row.id){
            setPermission(row)
            setModal({...modal,show:true,update:true})
        }else{
            setModal({...modal,show:true,update:false})
        }
    }
    const destroy = (id) => {
        DestroyAlertHelper(async confirmed => {
            if (!confirmed) { return; }
            deletePermission(id).then(response => {
                Alert(response.message,response.status)
                if (response.status) {
                    setItems(
                        items.filter(i => i.id != id)
                    );
                }           
            })
        });
    }
    const columns = Columns(addUpd,destroy);
	document.title = "Permissions | Minia - Permissions Template";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="col-12">
                        <DataTableHelper tittle="Permisos" columns={columns} items={items} pending={pending} config={dataPag} filters={filters} setFilters={setFilters}>
                            <button className="btn btn-sm btn-success" onClick={() => addUpd(permission)}><i className="fas fa-solid fa-plus"></i> Agregar</button>
                        </DataTableHelper>
                    </div>
                </Container>
                {modal.show &&
                    <AddUpdModal 
                        modal={modal}
                        setModal={setModal}
                        items={items}
                        setItems={setItems}
                        permission={permission}
                        setPermission={setPermission}
                    />
                }
            </div>
        </React.Fragment>
    );
};

export default Permissions;